import endOfScool from '../../images/ourHistory/End-of-School-Year-1967-1968.jpeg';
import oldLogo from '../../images/ourHistory/old-logo.jpeg';
import motherDay from '../../images/ourHistory/Mothers-Day-celebration-1974-1975.jpeg';
import mychajloSzynkaruk from '../../images/ourHistory/Mychajlo-Szynkaruk---Head-Teacher-at-St.-Marys-Ukrainian-School-1965-2001.jpeg';
import schoolStudents from '../../images/ourHistory/School-students-1982---1992.jpeg';
import MainBlockLayout from '../../components/MainBlockLayout';
import { Trans } from 'react-i18next';
import './OurHistory.css';

const SIGNIFICANT_CHANGES_LIST = ['re-established', 'curriculum has been', 'learning groups',
  'safeguarding', 'technical equipment', 'expanded beyond books', 'activities',
  'liaison and communication', 'events and participation', 'above changes'];

// One entry per period, oldest first. Each entry is drawn as a card on the timeline.
// - year:  badge text (not translated)
// - text:  translation key of the paragraph(s)
// - image / alt / side: optional photo; side=true floats it next to the text on desktop
// To add a period, add a line here (the "start creating" text is not used:
// it repeats the first paragraph of "first try to organise school").
const HISTORY = [
  { year: '1946', text: 'over 60 years', image: endOfScool, alt: 'End of School Year 1967-1968' },
  { year: '1947–1954', text: 'first try to organise school', image: oldLogo, alt: 'Old school logo', side: true },
  { year: '1956', text: 'in 1956', image: motherDay, alt: 'Mothers Day celebration 1974-1975' },
  { year: '1965', text: 'in 1965', image: mychajloSzynkaruk, alt: 'Mychajlo Szynkaruk, Head Teacher 1965-2001', side: true },
  { year: '2001', text: 'in 2001', image: schoolStudents, alt: 'School students 1982-1992' },
];

function MainBlock() {
  return (
    <div className="timeline">
      {HISTORY.map((item) => (
        <div key={item.year} className="timelineItem">
          <span className="timelineYear">{item.year}</span>
          <div className="timelineCard">
            {item.image && (
              <img className={item.side ? 'timelineImgSide' : ''} src={item.image} alt={item.alt} />
            )}
            <Trans i18nKey={item.text} />
          </div>
        </div>
      ))}

      <div className="timelineItem">
        <span className="timelineYear">2014</span>
        <div className="timelineCard">
          <Trans i18nKey="in 2014" />
          <ul>
            {SIGNIFICANT_CHANGES_LIST.map((key) => (
              <li key={key}><Trans i18nKey={key} /></li>
            ))}
          </ul>
        </div>
      </div>

      <div className="timelineItem timelineToday">
        <span className="timelineYear"><Trans i18nKey="history_today" /></span>
        <div className="timelineCard">
          <Trans i18nKey="today our school" />
        </div>
      </div>
    </div>
  );
}

export default MainBlockLayout(MainBlock);
